<div class="gallery-wrap bg-tertiary opacity-[0.98]">
  <div class="gallery-container">
    <div *ngIf="!isMobile" class="gallery__header">
      <div class="gallery__swiper-pagination-fraction">
        {{
          isHowItWorks
            ? +activeSlideIndex + 1 + '/' + (+galleryPics.length + 1)
            : +activeSlideIndex + 1 + '/' + galleryPics.length
        }}
      </div>

      <h5 class="gallery__title">{{ title }}</h5>

      <button
        sparkButton
        background="outline"
        variant="secondary"
        type="button"
        class="gallery__close bg-primary"
        (click)="removeComponent()"
      >
        <i class="fa-regular fa-xmark"></i>
      </button>
    </div>

    <div *ngIf="isMobile">
      <div class="gallery__header">
        <div class="gallery__swiper-pagination-fraction">
          {{
            isHowItWorks
              ? +activeSlideIndex + 1 + '/' + (+galleryPics.length + 1)
              : +activeSlideIndex + 1 + '/' + galleryPics.length
          }}
        </div>

        <button
          sparkButton
          background="outline"
          variant="secondary"
          type="button"
          class="gallery__close bg-primary"
          (click)="removeComponent()"
        >
          <i class="fa-regular fa-xmark"></i>
        </button>
      </div>
      <h5 class="gallery__title">{{ title }}</h5>

      <div class="gallery__info-tip">
        {{ 'gallery-images-note' | translate }}
      </div>
    </div>

    <div class="gallery">
      <div class="gallery__swiper" [class.gallery__swiper--landscape]="">
        <swiper-container
          #galleryImages
          class="gallery__swiper-top gallery__swiper-container"
          appSwiper
          init="false"
          thumbs-swiper=".gallery__swiper-thumbs"
          [config]="swiperConfig"
        >
          <ng-container *ngFor="let galleryPic of galleryPics; let i = index">
            <ng-container *ngIf="isHowItWorks; else defaultGallery">
              <ng-container *ngIf="galleryPics.length > 2">
                <ng-template
                  *ngIf="i < 2"
                  [ngTemplateOutlet]="galleryItem"
                  [ngTemplateOutletContext]="{
                    galleryPic: galleryPic,
                    index: i
                  }"
                ></ng-template>
                <ng-template *ngIf="i === 2" [ngTemplateOutlet]="howItWorks"></ng-template>
                <ng-template
                  *ngIf="i >= 2"
                  [ngTemplateOutlet]="galleryItem"
                  [ngTemplateOutletContext]="{
                    galleryPic: galleryPic,
                    index: i
                  }"
                ></ng-template>
              </ng-container>
              <ng-container *ngIf="galleryPics.length <= 2">
                <ng-template
                  [ngTemplateOutlet]="galleryItem"
                  [ngTemplateOutletContext]="{
                    galleryPic: galleryPic,
                    index: i
                  }"
                ></ng-template>
              </ng-container>
            </ng-container>
            <ng-template #defaultGallery>
              <ng-template
                [ngTemplateOutlet]="galleryItem"
                [ngTemplateOutletContext]="{
                  galleryPic: galleryPic,
                  index: i
                }"
              ></ng-template>
            </ng-template>
          </ng-container>
          <ng-template *ngIf="isHowItWorks && galleryPics.length <= 2" [ngTemplateOutlet]="howItWorks"></ng-template>
        </swiper-container>

        <swiper-container
          *ngIf="!isMobile"
          #galleryThumbs
          class="gallery__swiper-thumbs"
          appSwiper
          [config]="swiperThumbsConfig"
        >
          <ng-container *ngFor="let galleryPic of galleryPics; let i = index">
            <ng-container *ngIf="isHowItWorks; else defaultGalleryThumb">
              <ng-container *ngIf="galleryPics.length > 2">
                <ng-template
                  *ngIf="i < 2"
                  [ngTemplateOutlet]="galleryItemThumb"
                  [ngTemplateOutletContext]="{
                    galleryPic: galleryPic,
                    index: i
                  }"
                ></ng-template>
                <ng-template *ngIf="i === 2" [ngTemplateOutlet]="galleryHowItWorksItemThumb"></ng-template>
                <ng-template
                  *ngIf="i >= 2"
                  [ngTemplateOutlet]="galleryItemThumb"
                  [ngTemplateOutletContext]="{
                    galleryPic: galleryPic,
                    index: i
                  }"
                ></ng-template>
              </ng-container>
              <ng-container *ngIf="galleryPics.length <= 2">
                <ng-template
                  [ngTemplateOutlet]="galleryItemThumb"
                  [ngTemplateOutletContext]="{
                    galleryPic: galleryPic,
                    index: i
                  }"
                ></ng-template>
              </ng-container>
            </ng-container>
            <ng-template #defaultGalleryThumb>
              <ng-template
                [ngTemplateOutlet]="galleryItemThumb"
                [ngTemplateOutletContext]="{
                  galleryPic: galleryPic,
                  index: i
                }"
              ></ng-template>
            </ng-template>
          </ng-container>
          <ng-template
            *ngIf="isHowItWorks && galleryPics.length <= 2"
            [ngTemplateOutlet]="galleryHowItWorksItemThumb"
          ></ng-template>
        </swiper-container>

        <div *ngIf="!isMobile" class="gallery__info-tip">
          <i class="fa-regular fa-circle-info gallery__info-tip-icon"></i>
          {{ 'gallery-images-note' | translate }}
        </div>

        <div *ngIf="!isMobile" class="gallery__navigation">
          <button
            sparkButton
            background="outline"
            variant="secondary"
            type="button"
            class="swiper-button-prev gallery__swiper-btn-prev bg-primary"
            (click)="slideToPrev()"
          >
            <i class="fa-regular fa-arrow-left"></i>
          </button>

          <button
            sparkButton
            background="outline"
            variant="secondary"
            type="button"
            class="swiper-button-next gallery__swiper-btn-next bg-primary"
            (click)="slideToNext()"
          >
            <i class="fa-regular fa-arrow-right"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #howItWorks>
  <swiper-slide class="gallery__swiper-slide">
    <app-how-it-works />
  </swiper-slide>
</ng-template>
<ng-template #galleryItem let-galleryPic="galleryPic" let-index="index">
  <swiper-slide class="gallery__swiper-slide">
    <div class="gallery__img-item">
      <picture [ngClass]="galleryPic.isPortrait === true ? 'portrait' : 'landscape'">
        <app-tag-image
          *ngIf="isShowTags"
          [pictureTagId]="'qa_unit-img-tag-' + index"
          [pictureTag]="galleryPic.tags[0]"
          [class]="'images-gallery'"
        />

        <!--Desktop-->
        <source media="(min-width: 1024px)" [attr.data-srcset]="galleryPic.url + '?w=1196&h=700&auto=format'" />

        <!--Tablet devices-->
        <source
          *ngIf="galleryPic.isPortrait === false"
          media="(min-width: 768px)"
          [attr.data-srcset]="galleryPic.url + '?w=700&h=500&auto=format'"
        />
        <source
          *ngIf="galleryPic.isPortrait === true"
          media="(min-width: 768px)"
          [attr.data-srcset]="galleryPic.url + '?w=1300&h=657&auto=format'"
        />

        <!--Mobile devices-->
        <img
          appImageFallback
          class="lazyload responsive-img gallery__img"
          alt=""
          src="{{ imagePlaceholder + updateDefaultImageSizes(galleryPic.isPortrait) }}"
          [attr.data-src]="galleryPic.url + '?w=800&h=406&auto=format'"
          [ngClass]="galleryPic.isPortrait === true ? 'gallery__img--portrait' : 'gallery__img--landscape'"
          id="qa_unit-gallery-img-{{ index }}"
        />
      </picture>
    </div>
  </swiper-slide>
</ng-template>
<ng-template #galleryItemThumb let-galleryPic="galleryPic" let-index="index">
  <swiper-slide class="gallery__swiper-thumbs-slide">
    <img
      appImageFallback
      class="lazyload responsive-img"
      alt=""
      src="{{ imagePlaceholder + '?w=160&h=160&auto=format' }}"
      [attr.data-src]="galleryPic.url + '?w=160&h=160&auto=format'"
      [ngClass]="'gallery__swiper-thumbs-img'"
      id="qa_unit-gallery-thumbs-img-{{ index }}"
    />
  </swiper-slide>
</ng-template>
<ng-template #galleryHowItWorksItemThumb let-galleryPic="galleryPic" let-index="index">
  <swiper-slide class="gallery__swiper-thumbs-slide">
    <img
      appImageFallback
      class="lazyload responsive-img"
      alt="How it works"
      id="qa_unit-gallery-thumbs-img-how-it-works"
      src="{{ imagePlaceholder + '?w=160&h=160&auto=format' }}"
      [attr.data-src]="environment.imgixHost + '/website/how-it-works/how-it-works.jpeg?w=160&h=160&auto=format'"
      [ngClass]="'gallery__swiper-thumbs-img'"
    />
  </swiper-slide>
</ng-template>
